<template>
  <page>
    <div>
        <form>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Ageing</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs6>
                          <v-autocomplete
                            :items="rptTypeList"
                            v-model="reportForm.rptType"
                            :label="labels.rptType"
                            item-text="label"
                            item-value="value"
                            data-vv-name="rptType"
                            :data-vv-as="labels.stmtFor"
                            :error-messages="errors.collect('rptType')"
                            v-validate="'required'"
                            @change="disableSorting"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs6>
                          <v-autocomplete
                            :items="ageByList"
                            v-model="reportForm.ageBy"
                            :label="labels.ageBy"
                            item-text="label"
                            item-value="value"
                            data-vv-name="ageBy"
                            :data-vv-as="labels.ageBy"
                            :error-messages="errors.collect('ageBy')"
                            v-validate="'required'"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs2>
                          <cal-picker
                            v-model="reportForm.currMth"
                            :label="labels.currMth"
                            v-validate="ageingValidate(0)"
                            :data-vv-as="labels.currMth"
                            data-vv-name="currMth"
                            :error-messages="errors.collect('currMth')"
                            :max="new Date()"
                            @change="doDefAgePeriod"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs4>
                          <v-text-field
                            v-model="reportForm.colHeadCurrMth"
                            :label="labels.colHeadCurrMth"
                            :error-messages="errors.collect('colHeadCurrMth')"
                            data-vv-name="colHeadCurrMth"
                            :data-vv-as="labels.colHeadCurrMth"
                            v-validate="'required|max:10'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs2>
                          <cal-picker
                            v-model="reportForm.agePer1"
                            :label="labels.agePer1"
                            v-validate="ageingValidate(1)"
                            :data-vv-as="labels.agePer1"
                            data-vv-name="agePer1"
                            :error-messages="errors.collect('agePer1')"
                            :max="getMaxAgeing(1)"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs4>
                          <v-text-field
                            v-model="reportForm.colHeadAgePer1"
                            :label="labels.colHeadAgePer1"
                            :error-messages="errors.collect('colHeadAgePer1')"
                            data-vv-name="colHeadAgePer1"
                            :data-vv-as="labels.colHeadAgePer1"
                            v-validate="'required|max:10'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs2>
                          <cal-picker
                            v-model="reportForm.agePer2"
                            :label="labels.agePer2"
                            v-validate="ageingValidate(2)"
                            :data-vv-as="labels.agePer2"
                            data-vv-name="agePer2"
                            :error-messages="errors.collect('agePer2')"
                            :max="getMaxAgeing(2)"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs4>
                          <v-text-field
                            v-model="reportForm.colHeadAgePer2"
                            :label="labels.colHeadAgePer2"
                            :error-messages="errors.collect('colHeadAgePer2')"
                            data-vv-name="colHeadAgePer2"
                            :data-vv-as="labels.colHeadAgePer2"
                            v-validate="'required|max:10'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs2>
                          <cal-picker
                            v-model="reportForm.agePer3"
                            :label="labels.agePer3"
                            v-validate="ageingValidate(3)"
                            :data-vv-as="labels.agePer3"
                            data-vv-name="agePer3"
                            :error-messages="errors.collect('agePer3')"
                            :max="getMaxAgeing(3)"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs4>
                          <v-text-field
                            v-model="reportForm.colHeadAgePer3"
                            :label="labels.colHeadAgePer3"
                            :error-messages="errors.collect('colHeadAgePer3')"
                            data-vv-name="colHeadAgePer3"
                            :data-vv-as="labels.colHeadAgePer3"
                            v-validate="'required|max:10'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs2>
                          <cal-picker
                            v-model="reportForm.agePer4"
                            :label="labels.agePer4"
                            v-validate="ageingValidate(4)"
                            :data-vv-as="labels.agePer4"
                            data-vv-name="agePer4"
                            :error-messages="errors.collect('agePer4')"
                            :max="getMaxAgeing(4)"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs4>
                          <v-text-field
                            v-model="reportForm.colHeadAgePer4"
                            :label="labels.colHeadAgePer4"
                            :error-messages="errors.collect('colHeadAgePer4')"
                            data-vv-name="colHeadAgePer4"
                            :data-vv-as="labels.colHeadAgePer4"
                            v-validate="'required|max:10'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs2>
                          <cal-picker
                            v-model="reportForm.agePer5"
                            :label="labels.agePer5"
                            v-validate="ageingValidate(5)"
                            :data-vv-as="labels.agePer5"
                            data-vv-name="agePer5"
                            :error-messages="errors.collect('agePer5')"
                            :max="getMaxAgeing(5)"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs4>
                          <v-text-field
                            v-model="reportForm.colHeadAgePer5"
                            :label="labels.colHeadAgePer5"
                            :error-messages="errors.collect('colHeadAgePer5')"
                            data-vv-name="colHeadAgePer5"
                            :data-vv-as="labels.colHeadAgePer5"
                            v-validate="'required|max:10'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs2>
                          <cal-picker
                            v-model="reportForm.agePer6"
                            :label="labels.agePer6"
                            v-validate="ageingValidate(6)"
                            :data-vv-as="labels.agePer6"
                            data-vv-name="agePer6"
                            :error-messages="errors.collect('agePer6')"
                            :max="getMaxAgeing(6)"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs4>
                          <v-text-field
                            v-model="reportForm.colHeadAgePer6"
                            :label="labels.colHeadAgePer6"
                            :error-messages="errors.collect('colHeadAgePer6')"
                            data-vv-name="colHeadAgePer6"
                            :data-vv-as="labels.colHeadAgePer6"
                            v-validate="'required|max:10'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs2>
                          <cal-picker
                            v-model="reportForm.agePer7"
                            :label="labels.agePer7"
                            v-validate="ageingValidate(7)"
                            :data-vv-as="labels.agePer7"
                            data-vv-name="agePer7"
                            :error-messages="errors.collect('agePer7')"
                            :max="getMaxAgeing(7)"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs4>
                          <v-text-field
                            v-model="reportForm.colHeadAgePer7"
                            :label="labels.colHeadAgePer7"
                            :error-messages="errors.collect('colHeadAgePer7')"
                            data-vv-name="colHeadAgePer7"
                            :data-vv-as="labels.colHeadAgePer7"
                            v-validate="'required|max:10'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs2>
                          <cal-picker
                            v-model="reportForm.agePer8"
                            :label="labels.agePer8"
                            v-validate="ageingValidate(8)"
                            :data-vv-as="labels.agePer8"
                            data-vv-name="agePer8"
                            :error-messages="errors.collect('agePer8')"
                            :max="getMaxAgeing(8)"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs4>
                          <v-text-field
                            v-model="reportForm.colHeadAgePer8"
                            :label="labels.colHeadAgePer8"
                            :error-messages="errors.collect('colHeadAgePer8')"
                            data-vv-name="colHeadAgePer8"
                            :data-vv-as="labels.colHeadAgePer8"
                            v-validate="'required|max:10'"
                          ></v-text-field>
                        </v-flex>
                        <!-- <v-flex xs2>
                        <cal-picker v-model="reportForm.agePer9" :label="labels.agePer9" v-validate="ageingValidate(9)" :data-vv-as="labels.agePer9" data-vv-name="agePer9" :error-messages="errors.collect('agePer9')" :max="getMaxAgeing(9)"></cal-picker>
                      </v-flex>
                      <v-flex xs4>
                        <v-text-field v-model="reportForm.colHeadAgePer9" :label="labels.colHeadAgePer9" :error-messages="errors.collect('colHeadAgePer9')" data-vv-name="colHeadAgePer9" :data-vv-as="labels.colHeadAgePer9" v-validate="'required|max:10'"></v-text-field>
                      </v-flex> -->
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-divider></v-divider>
          <v-spacer class="mt-2"></v-spacer>
          <v-expansion-panels v-model="panel2" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Selection Criteria</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs6>
                          <!-- <v-autocomplete :items="interListFrom" v-model="reportForm.acctNoFrom" :label="labels.acctNoFrom" item-text="label" item-value="value" data-vv-name="acctNoFrom" :data-vv-as="labels.acctNoFrom" :error-messages="errors.collect('acctNoFrom')" v-validate="acctNoValidate('from')"></v-autocomplete> -->
                          <v-text-field
                            v-model="reportForm.acctNoFrom"
                            :label="labels.acctNoFrom"
                            :error-messages="errors.collect('acctNoFrom')"
                            data-vv-name="acctNoFrom"
                            :data-vv-as="labels.acctNoFrom"
                            append-icon="mdi-magnify"
                            @click:append="getHelpList('acctNoFrom')"
                            v-validate="acctNoValidate('from')"
                            readonly
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <!-- <v-autocomplete :items="interListTo" v-model="reportForm.acctNoTo" :label="labels.acctNoTo" item-text="label" item-value="value" data-vv-name="acctNoTo" :data-vv-as="labels.acctNoTo" :error-messages="errors.collect('acctNoTo')" v-validate="acctNoValidate('to')" :disabled="acctNoToDisc"></v-autocomplete> -->
                          <v-text-field
                            v-model="reportForm.acctNoTo"
                            :label="labels.acctNoTo"
                            :error-messages="errors.collect('acctNoTo')"
                            data-vv-name="acctNoTo"
                            :data-vv-as="labels.acctNoTo"
                            append-icon="mdi-magnify"
                            @click:append="getHelpList('acctNoTo')"
                            v-validate="acctNoValidate('to')"
                            :disabled="acctNoToDisc"
                            readonly
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xs6>
                          <v-autocomplete
                            :items="ageByList"
                            v-model="reportForm.dateRangeBy"
                            :label="labels.dateRangeBy"
                            item-text="label"
                            item-value="value"
                            data-vv-name="dateRangeBy"
                            :data-vv-as="labels.dateRangeBy"
                            :error-messages="errors.collect('dateRangeBy')"
                            v-validate="'required'"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs3>
                          <cal-picker
                            v-model="reportForm.tranDateFrom"
                            :label="labels.tranDateFrom"
                            v-validate="tranDateValidation('from')"
                            :data-vv-as="labels.tranDateFrom"
                            data-vv-name="tranDateFrom"
                            :error-messages="errors.collect('tranDateFrom')"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs3>
                          <cal-picker
                            v-model="reportForm.tranDateTo"
                            :label="labels.tranDateTo"
                            v-validate="tranDateValidation('to')"
                            :data-vv-as="labels.toDate1"
                            data-vv-name="tranDateTo"
                            :error-messages="errors.collect('tranDateTo')"
                          ></cal-picker>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xs6>
                          <v-text-field
                            v-model="reportForm.branch"
                            :label="labels.branch"
                            :error-messages="errors.collect('branch')"
                            data-vv-name="branch"
                            :data-vv-as="labels.branch"
                            append-icon="mdi-magnify"
                            @click:append="getHelpList('branch')"
                            v-validate="'required'"
                            readonly
                          ></v-text-field>
                        </v-flex>
                        <!-- <v-flex xs6>
                          <v-text-field
                            v-model="reportForm.homeBrn"
                            :label="labels.homeBrn"
                            :error-messages="errors.collect('homeBrn')"
                            data-vv-name="homeBrn"
                            :data-vv-as="labels.homeBrn"
                            append-icon="mdi-magnify"
                            @click:append="getHelpList('homeBrn')"
                            v-validate="'required'"
                            readonly
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap> -->
                        <v-flex xs6>
                          <!-- <v-text-field v-model="reportForm.interType" :label="labels.interType" :error-messages="errors.collect('interType')" data-vv-name="interType" :data-vv-as="labels.interType" append-icon="mdi-magnify" @click:append="getHelpList('interType')" readonly></v-text-field> -->
                          <v-text-field
                            v-model="reportForm.interGrp"
                            :label="labels.interGrp"
                            :error-messages="errors.collect('interGrp')"
                            data-vv-name="interGrp"
                            :data-vv-as="labels.interGrp"
                            append-icon="mdi-magnify"
                            @click:append="getHelpList('interGrp')"
                            readonly
                          ></v-text-field>
                        </v-flex>
                        <!-- <v-flex xs6>
                          <v-checkbox
                            v-model="reportForm.incZeroBalTran"
                            :label="labels.incZeroBalTran"
                            data-vv-name="incZeroBalTran"
                            :data-vv-as="labels.incZeroBalTran"
                          ></v-checkbox>
                        </v-flex> -->
                      </v-layout>
                      <!-- <v-layout row wrap>
                        <v-flex xs6>
                          <v-radio-group
                            row
                            v-model="reportForm.sorting"
                            :error-messages="errors.collect('sorting')"
                            data-vv-name="sorting"
                            :data-vv-as="labels.sorting"
                            :disabled="disabledSorting"
                          >
                            <v-radio :key="sortingList[0].value" :label="sortingList[0].label" :value="sortingList[0].value"></v-radio>
                          </v-radio-group>
                        </v-flex>
                        <v-flex xs6>
                          <v-checkbox
                            v-model="reportForm.sepFigCrDr"
                            :label="labels.sepFigCrDr"
                            data-vv-name="sepFigCrDr"
                            :data-vv-as="labels.sepFigCrDr"
                            :disabled="crdrDisc"
                          ></v-checkbox>
                        </v-flex>
                      </v-layout> -->
                      <v-layout row wrap>
                        <!-- <v-flex xs6>
                          <v-radio-group
                            row
                            v-model="reportForm.sorting"
                            :error-messages="errors.collect('sorting')"
                            data-vv-name="sorting"
                            :data-vv-as="labels.sorting"
                            :disabled="disabledSorting"
                          >
                            <v-radio :key="sortingList[1].value" :label="sortingList[1].label" :value="sortingList[1].value"></v-radio>
                          </v-radio-group>
                        </v-flex> -->
                        <v-flex xs6>
                          <v-checkbox
                            v-model="reportForm.aplCrTermsToAgeing"
                            :label="labels.aplCrTermsToAgeing"
                            data-vv-name="aplCrTermsToAgeing"
                            :data-vv-as="labels.aplCrTermsToAgeing"
                          ></v-checkbox>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
        <v-dialog v-model="helplist" width="900px" persistent>
          <helplist :apiURI="apiURI" :mode="mode" :param="param" @close="doClose" @doAssign="doAssign($event)">
          </helplist>
        </v-dialog>
        <v-dialog v-model="acctNoFromList" width="900px" persistent>
          <acctNo-help-list :mode="mode" @close="doClose" @assign-acct-info="doAssignAcctNo"></acctNo-help-list>
        </v-dialog>
        <v-dialog v-model="acctNoToList" width="900px" persistent>
          <acctNo-help-list :mode="mode" @close="doClose" @assign-acct-info="doAssignAcctNo"></acctNo-help-list>
        </v-dialog>
        <v-dialog v-model="interGrpHelpList" width="900px" persistent>
          <inter-grp-help-list :mode="mode" :param="param" @close="doClose"
            @doAssign="doAssign($event)"></inter-grp-help-list>
        </v-dialog>
        <v-dialog v-model="scheduleJobModal" width="1000px" persistent>
          <ScheduleJob @close="scheduleJobModal = false" :jobName="jobName" :jobDesc="jobDesc"></ScheduleJob>
        </v-dialog>
      <v-flex xs12 class="pt-3">
        <v-checkbox v-model="reportForm.prtRptRunTime" :label="labels.prtRptRunTime" data-vv-name="prtRptRunTime"
          :data-vv-as="labels.prtRptRunTime"></v-checkbox>
        <!-- <v-btn class="mr-2" color="info" :loading="submitting" @click.prevent="doSchedule">
          <v-icon left dark>mdi-clock</v-icon>
          Schedule
        </v-btn> -->
        <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
          <v-icon left dark>mdi-file-export</v-icon>
          {{ labels.export }}
        </v-btn>
        <v-btn-toggle dense mandatory v-model="reportForm.format">
          <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
            <span>{{ format.label }}</span>
            <v-icon :color="format.color">{{ format.icon }}</v-icon>
          </v-btn>
        </v-btn-toggle>
      </v-flex>
    </div>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import Helplist from '../Helplist'
import AcctNoHelpList from './AcctNoHelpList'
import InterGrpHelpList from './InterGrpHelpList'
import ScheduleJob from '@/components/core/common/dialog/ScheduleJob'
import {
  labels,
  rptTypeList,
  ageByList,
  sortingList,
  acctNoRangeFrom,
  acctNoRangeTo,
  checkDateRangeTo,
  checkDateRangeFrom,
  checkCurrMth,
  checkAgeing,
  interGrpList
} from './index'

export default {
  data() {
    return {
      labels: {},
      // expansion control
      toogleAgeing: [true],
      tooglePrtOp: [false],
      reportForm: {
        // Ageing
        rptType: 5,
        ageBy: 'A',
        currMth: new Date(),
        agePer1: null,
        agePer2: null,
        agePer3: null,
        agePer4: null,
        agePer5: null,
        agePer6: null,
        agePer7: null,
        agePer8: null,
        agePer9: null,
        colHeadCurrMth: null,
        colHeadAgePer1: null,
        colHeadAgePer2: null,
        colHeadAgePer3: null,
        colHeadAgePer4: null,
        colHeadAgePer5: null,
        colHeadAgePer6: null,
        colHeadAgePer7: null,
        colHeadAgePer8: null,
        colHeadAgePer9: null,
        // Print Option
        acctNoFrom: 'All',
        acctNoTo: '',
        dateRangeBy: 'T',
        tranDateFrom: null,
        tranDateTo: null,
        branch: 'All',
        homeBrn: 'All',
        interType: 'All',
        interGrp: 'All',
        incZeroBalTran: false,
        sorting: 1,
        aplCrTermsToAgeing: false,
        sepFigCrDr: false,
        prtRptRunTime: true,
        // unDueTranCommDate: false,
        format: undefined
      },
      // HelpList
      helplist: false,
      acctNoFromList: false,
      acctNoToList: false,
      interGrpHelpList: false,
      apiURI: '',
      mode: '',
      param: '',
      // DropDown List
      interListFrom: [{ label: 'All', value: 'All' }],
      interListTo: [],
      ageByList: [],
      rptTypeList: [],
      sortingList: [],
      interGrpList: [],
      // event counter
      acctNoToDisc: true,
      undueDisc: true,
      crdrDisc: false,
      // Other
      menu: {},
      supportedFormat: [],
      submitting: false,
      disabledSorting: false,
      scheduleJobModal: false,
      jobName: 'qrtzAgedDebtorsAnalysis',
      jobDesc: 'Aged Debtors Analysis',
      panel1: [0],
      panel2: [0]
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.accountReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map((format) => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  watch: {
    supportedList: function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.reportForm.format = value[0].value
      }
    },
    'reportForm.acctNoFrom': function (value) {
      if (value === 'All') {
        this.reportForm.acctNoTo = ''
        this.acctNoToDisc = true
      } else {
        this.acctNoToDisc = false
      }
    },
    'reportForm.rptType': function (value) {
      if (value < 4) {
        this.undueDisc = true
      } else {
        this.undueDisc = false
      }
      if (value > 2) {
        this.crdrDisc = true
      } else {
        this.crdrDisc = false
      }
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.accountReports.init !== 1) {
          await this.$store.dispatch('accountReportsInit')
        }
        const apiURI = this.rptMenu.agedDebtorsAnalysis
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
          this.getInterList()
          this.doDefAgePeriod()
        }
      } catch (err) {
        throw err
      }
    },
    doDefAgePeriod() {
      for (let i = 0; i <= 8; i++) {
        var day = this.reportForm.currMth.getDate()
        var month = this.reportForm.currMth.getMonth()
        var year = this.reportForm.currMth.getFullYear()
        var a = new Date(year, month, day)
        a.setMonth(a.getMonth() - i)
        this.reportForm['agePer' + i] = a
      }
    },
    async getInterList() {
      const apiURI = this.menu.getAllInterList
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          data.map((inter) => {
            const convertList = {
              label: inter.label,
              value: inter.value
            }
            this.interListFrom.push(convertList)
            this.interListTo.push(convertList)
          })
        }
      }
    },
    acctNoValidate(field) {
      if (field === 'from') {
        if (this.reportForm.acctNoFrom === 'All' || this.reportForm.acctNoTo === '') {
          return 'required'
        } else {
          if (this.reportForm.acctNoTo) {
            return 'required|acctNoRangeFrom:' + this.reportForm.acctNoTo
          } else {
            return 'required'
          }
        }
      } else {
        if (this.reportForm.acctNoFrom === 'All') {
          return ''
        } else {
          if (this.reportForm.acctNoFrom) {
            return 'required|acctNoRangeTo:' + this.reportForm.acctNoFrom
          } else {
            return 'required'
          }
        }
      }
    },
    ageingValidate(period) {
      var valStr = 'required'
      if (period === 0) {
        valStr = valStr + '|checkCurrMth'
      } else if (period === 1) {
        if (this.reportForm.currMth) {
          valStr = valStr + '|checkAgeing:' + this.reportForm.currMth
        }
      } else if (period === 2) {
        if (this.reportForm.agePer1) {
          valStr = valStr + '|checkAgeing:' + this.reportForm.agePer1
        }
      } else if (period === 3) {
        if (this.reportForm.agePer2) {
          valStr = valStr + '|checkAgeing:' + this.reportForm.agePer2
        }
      } else if (period === 4) {
        if (this.reportForm.agePer3) {
          valStr = valStr + '|checkAgeing:' + this.reportForm.agePer3
        }
      } else if (period === 5) {
        if (this.reportForm.agePer4) {
          valStr = valStr + '|checkAgeing:' + this.reportForm.agePer4
        }
      } else if (period === 6) {
        if (this.reportForm.agePer5) {
          valStr = valStr + '|checkAgeing:' + this.reportForm.agePer5
        }
      } else if (period === 7) {
        if (this.reportForm.agePer6) {
          valStr = valStr + '|checkAgeing:' + this.reportForm.agePer6
        }
      } else if (period === 8) {
        if (this.reportForm.agePer7) {
          valStr = valStr + '|checkAgeing:' + this.reportForm.agePer7
        }
      } else {
        if (this.reportForm.agePer8) {
          valStr = valStr + '|checkAgeing:' + this.reportForm.agePer8
        }
      }
      return valStr
    },
    getMaxAgeing(period) {
      if (this.reportForm.ageBy !== 'A') {
        switch (period) {
          case 1:
            return this.reportForm.currMth
          case 2:
            return this.reportForm.agePer1
          case 3:
            return this.reportForm.agePer2
          case 4:
            return this.reportForm.agePer3
          case 5:
            return this.reportForm.agePer4
          case 6:
            return this.reportForm.agePer5
          case 7:
            return this.reportForm.agePer6
          case 8:
            return this.reportForm.agePer7
          case 9:
            return this.reportForm.agePer8
        }
      }
    },
    tranDateValidation(field) {
      if (field === 'from') {
        if (this.reportForm.tranDateTo) {
          return 'checkDateRangeFrom:' + this.reportForm.tranDateTo
        } else {
          return 'checkDateRangeFrom'
        }
      } else {
        if (this.reportForm.tranDateFrom) {
          return 'checkDateRangeTo:' + this.reportForm.tranDateFrom
        } else {
          return 'checkDateRangeTo'
        }
      }
    },
    getHelpList(fieldName) {
      this.mode = fieldName
      if (fieldName === 'branch') {
        this.apiURI = this.menu.getBranchList
        this.param = this.reportForm.branch
        this.helplist = true
      } else if (fieldName === 'homeBrn') {
        this.apiURI = this.menu.getBranchList
        this.param = this.reportForm.homeBrn
        this.helplist = true
      } else if (fieldName === 'interType') {
        this.apiURI = this.menu.getInterTypeList
        this.param = this.reportForm.interType
        this.helplist = true
      } else if (fieldName === 'acctNoFrom') {
        this.acctNoFromList = true
      } else if (fieldName === 'acctNoTo') {
        this.acctNoToList = true
      } else if (fieldName === 'interGrp') {
        this.param = this.reportForm.interGrp
        this.interGrpHelpList = true
      }
    },
    doClose() {
      this.helplist = false
      this.acctNoFromList = false
      this.acctNoToList = false
      this.interGrpHelpList = false
    },
    doAssign(Obj) {
      switch (this.mode) {
        case 'branch':
          this.reportForm.branch = ''
          this.reportForm.branch = Obj.finalSelectedItems.toString()
          break
        case 'homeBrn':
          this.reportForm.homeBrn = ''
          this.reportForm.homeBrn = Obj.finalSelectedItems.toString()
          break
        case 'interType':
          this.reportForm.interType = ''
          this.reportForm.interType = Obj.finalSelectedItems.toString()
          break
        case 'interGrp':
          this.reportForm.interGrp = ''
          this.reportForm.interGrp = Obj.finalSelectedItems.toString()
          break
      }
    },
    doAssignAcctNo(data) {
      switch (this.mode) {
        case 'acctNoFrom':
          this.reportForm.acctNoFrom = ''
          if (data === 'All') {
            this.reportForm.acctNoFrom = data
          } else {
            this.reportForm.acctNoFrom = data.inter
          }
          break
        case 'acctNoTo':
          this.reportForm.acctNoTo = ''
          if (data === 'All') {
            this.reportForm.acctNoTo = data
          } else {
            this.reportForm.acctNoTo = data.inter
          }
          break
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.processExport()
        }
      })
    },
    doSchedule() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.scheduleJob()
        }
      })
    },
    scheduleJob() {
      this.scheduleJobModal = true
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.reportForm)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    disableSorting() {
      if (this.reportForm.rptType > 3) {
        this.disabledSorting = true
      } else {
        this.disabledSorting = false
      }
    }
  },
  created() {
    this.doInit()
    this.labels = labels
    // assign dropdown list
    this.rptTypeList = rptTypeList
    this.ageByList = ageByList
    this.sortingList = sortingList
    this.interGrpList = interGrpList
    // custom validation
    this.$validator.extend('acctNoRangeFrom', acctNoRangeFrom)
    this.$validator.extend('acctNoRangeTo', acctNoRangeTo)
    this.$validator.extend('checkDateRangeFrom', checkDateRangeFrom)
    this.$validator.extend('checkDateRangeTo', checkDateRangeTo)
    this.$validator.extend('checkCurrMth', checkCurrMth)
    this.$validator.extend('checkAgeing', checkAgeing)
  },
  mixins: [MessageMixin],
  components: {
    Helplist,
    AcctNoHelpList,
    InterGrpHelpList,
    ScheduleJob
  }
}
</script>
